import useMutation from "src/hooks/useMutation";

function useCustomerImport() {
  return useMutation({
    path: "/api/v1/customers/import",
    method: "POST",
  });
}

export default useCustomerImport;
